import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useState } from "react";
import { fetchSingleProductWithIdentifier } from "../api/products.api";

interface UseProductProps {
  identifier?: string;
  companyId?: number;
}

const useProductWithIdentifier = ({
  identifier,
  companyId,
}: UseProductProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const {
    data: productData,
    error: productError,
    isLoading: isLoadingProduct,
    isSuccess: isSuccessProduct,
  } = useQuery({
    queryKey: ["products", identifier],
    queryFn: () =>
      fetchSingleProductWithIdentifier(
        bearerToken as string,
        companyId as number,
        identifier as string
      ),
    enabled: !!identifier && !!companyId,
  });

  return {
    productData,
    productError,
    isLoadingProduct,
  };
};

export default useProductWithIdentifier;
